module.exports = __webpack_public_path__ + "img/autocosmos.3f55e831.png";